import { Injectable } from '@angular/core';

@Injectable()
export class ExportCsvService {
    JsonToCsvConvertor(JSONData: any, documentName: string, showLabel: boolean) {
        //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
        const arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

        let CSV = '',
            row = "",
            index: any,
            x: number, lenX: number;

        //This condition will generate the Label/Header
        if (showLabel) {
            //This loop will extract the label from 1st index of on array
            for (index in arrData[0]) {

                //Now convert each value to string and comma-seprated
                row += index + ',';
            }

            row = row.slice(0, -1);

            //append Label row with line break
            CSV += row + '\r\n';
        }

        //1st loop is to extract each row
        for (x = 0, lenX = arrData.length; x < lenX; x++) {
            row = "";

            //2nd loop will extract each column and convert it in string comma-seprated
            for (index in arrData[x]) {
                row += '"' + arrData[x][index] + '",';
            }

            row.slice(0, row.length - 1);

            //add a line break after each row
            CSV += row + '\r\n';
        }

        if (CSV == '') {
            // alert("Invalid data");
            return;
        }

        // Generate a file name
        // this will remove the blank-spaces from the title and replace it with an underscore
        const fileName = documentName.replace(/ /g,"_");

        //Initialize file format you want csv or xls
        const uri = 'data:text/csv;charset=utf-8,' + encodeURI(CSV);

        // Now the little tricky part.
        // you can use either>> window.open(uri);
        // but this will not work in some browsers
        // or you will not get the correct file extension

        //this trick will generate a temp <a /> tag
        const link: any = document.createElement("a");
        link.href = uri;

        //set the visibility hidden so it will not effect on your web-layout
        link.style = "visibility:hidden";
        link.download = fileName + ".csv";

        //this part will append the anchor tag and remove it after automatic click
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/services/export-csv.service.ts
 **/